/**
 * Whether the public homepage shows the interactive demo launcher (Try It Free Now).
 */
export function isHomepageDemoLauncherEnabled() {
  return false;
}
